import { RiBuilding4Fill, RiBuilding2Fill, RiMiniProgramLine } from "react-icons/ri";
import { FaUsers, FaRegListAlt, FaChalkboardTeacher, FaRegCalendar } from "react-icons/fa";
import { ImUsers } from "react-icons/im";
import { RiRecycleFill } from "react-icons/ri";
import { CgTemplate } from "react-icons/cg";
import { RiSecurePaymentFill } from "react-icons/ri";
import { AiFillDollarCircle } from "react-icons/ai";
import { GiModernCity } from "react-icons/gi";
import { AiOutlineMail } from "react-icons/ai";
import { IoIosNotificationsOutline } from "react-icons/io";
import { MdCable, MdPayment, MdSchedule, MdViewList, MdAutoAwesome } from "react-icons/md";
import { FcCalendar, FcDataConfiguration, FcInvite } from "react-icons/fc";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { MdConnectedTv, MdFeedback } from "react-icons/md";
import { BsFillChatRightTextFill } from "react-icons/bs"
import { TbReportAnalytics, TbReportSearch, TbTemplate, TbTruckDelivery } from "react-icons/tb"
import { SiAzurepipelines } from "react-icons/si"
import TruckLogo from './images/better-truck-logo.svg'
import { MdPaid } from "react-icons/md";
import { ADHOC } from "../src/constants/variables/index";

const RootAndAdmin = ["root", "admin"];
const RootOnly = ["root"];
const BookkeeperOnly = ["bookkeeper"];
const RootAdnBookkeeper = ["root", "bookkeeper"];
const RootAdminAndBookkeeper = [...RootAndAdmin, ...BookkeeperOnly]
const RootAdminAndMetroManager = [...RootAndAdmin, "metro_manager"];

export const routesList = [
  {
    path: "Bettertrucks",
    name: "Better Trucks",
    icon: TruckLogo,
    role: RootAdminAndMetroManager,
    subPathArray: ['/hubs', '/metros', '/company', '/users'],
    subRoutes: [
      {
        path: "hubs",
        name: "Hubs",
        icon: <RiBuilding4Fill />,
        role: RootOnly
      },
      {
        path: "metros",
        name: "Metros",
        icon: <GiModernCity />,
        role: RootOnly
      },
      { path: "company", name: 'Company', icon: <RiBuilding2Fill />, role: RootOnly },
      {
        path: "users",
        name: 'Users',
        icon: <ImUsers />,
        currentUser: true,
        role: RootOnly,
      },
    ],
  },
  
  { path: "drivers", icon: <FaUsers />, role: RootAdminAndMetroManager },
  
  { path: "prospectDrivers", name: "Prospect Drivers", icon: <FcInvite />, role: RootOnly },

  {
    name: 'Operators',
    path: "operator",
    icon: <MdConnectedTv />,
    role: RootAndAdmin,
  },
  {
    path: "shiftsGroup",
    name: "Shifts",
    icon: <TbTruckDelivery />,
    role: RootAdminAndMetroManager,
    subPathArray: ['/shifts', '/scheduling', '/shiftstemplate'],
    subRoutes: [
      {
        path: "shifts",
        name: "All Shifts",
        icon: <MdViewList />,
        role: RootAdminAndMetroManager,
      },
      {
        path: "scheduling",
        name: "Scheduling Assistant",
        icon: <MdAutoAwesome />,
        role: RootAdminAndMetroManager,
      },
      {
        path: "shiftstemplate",
        icon: <TbTemplate />,
        name: "Shifts Template",
        role: RootAndAdmin,
      },
    ],
  },
  {
    path: "deposit",
    icon: <CgTemplate />,
    currentUser: true,
    role: BookkeeperOnly,
  },
  {
    path: "communication",
    name: "Driver communication",
    icon: <BsFillChatRightTextFill />,
    role: RootAdminAndMetroManager,
    subPathArray: ['/feedback', '/emails', '/notifications', '/drivercoaching'],
    subRoutes: [
      { path: "drivercoaching", icon: <FaChalkboardTeacher />, role: RootAdminAndMetroManager, name: "Driver Coaching" },
      { path: "feedback", icon: <MdFeedback />, role: RootAdminAndMetroManager },
      {
        path: "emails",
        icon: <AiOutlineMail />,
        role: RootAndAdmin,
      },
      {
        path: "notifications",
        icon: <IoIosNotificationsOutline />,
        role: RootAndAdmin,
      }
    ],
  },
  {
    path: "pay",
    name: "Payments",
    icon: <MdPayment />,
    role: RootAdminAndBookkeeper,
    subPathArray: ['/payments', '/paymentsCalendar', '/adhocpayment'],
    subRoutes: [
      {
        path: "payments",
        icon: <RiSecurePaymentFill />,
        role: RootAdnBookkeeper,
      },
      {
        path: "paymentsCalendar",
        icon: <FaRegCalendar />,
        role: RootOnly,
        name: 'Payment Calendar'
      },
      {
        path: "adhocpayment",
        icon: <RiRecycleFill />,
        name: ADHOC,
        role: RootAndAdmin,
      },
    ],
  },

  {
    path: "reports",
    name: "Reports",
    icon: <TbReportAnalytics />,
    role: RootAdminAndBookkeeper,
    subPathArray: ['/schedulers/pipeline_drivers', '/piplinestage', '/reports/drivers-earning', '/reports/transactions'],
    subRoutes: [
      {
        path: "schedulers",
        name: "Pipeline",
        icon: <SiAzurepipelines />,
        role: RootAndAdmin,
      },
      {
        path: "piplinestage",
        icon: <MdCable />,
        name: "Driver onboarding pipeline",
        role: RootAndAdmin,
      },
      {
        path: "/reports/drivers-earning",
        name: "Drivers Earning",
        icon: <AiFillDollarCircle />,
        role: RootAdnBookkeeper,
      },
      {
        path: "/reports/transactions",
        name: "Transactions",
        icon: <CompareArrowsIcon />,
        role: RootAdnBookkeeper,
      },
    ],
  },
  {
    path: "bonusCampaign",
    name: "Bonus",
    role: RootOnly,
    icon: <RiMiniProgramLine />,
    subPathArray: ['/bonusCampaign', '/bonusCampaign/disbursement', '/bonusCampaign/report'],
    subRoutes: [
      {
        path: "bonusCampaign",
        name: "Campaign",
        icon: <FcDataConfiguration />,
        role: RootOnly,
      },
      {
        path: "bonusCampaign/report",
        name: "Report",
        icon: <TbReportSearch />,
        role: RootOnly,
      },
      {
        path: "bonusCampaign/disbursement",
        name: "Disbursement",
        icon: <MdPaid />,
        role: RootOnly,
      }
    ],
  }
]